import { Box } from '@mui/material';
import Select, { components } from 'react-select';
import { LANGUAGES } from '../constants';
import dropdownIcon from '../assets/images/dropdown-icon.svg';

const DropdownIcon = () => (
  <img src={dropdownIcon} alt="" style={{ width: 20, height: 20 }} />
);

const CustomOption = (props) => {
  const { isSelected, children, innerRef, innerProps } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row-reverse',
        padding: '10px 14px',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        color: '#000',
        fontSize: '14px',
        fontFamily: '"Graphik Arabic", sans-serif',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f5f5f5'; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
    >
      <span>{children}</span>
      {isSelected && (
        <span style={{ color: '#000', fontSize: '14px', lineHeight: 1, flexShrink: 0 }}>✓</span>
      )}
    </div>
  );
};

function LanguageSelector({ 
  language, 
  country, 
  countryOptions, 
  onLanguageChange, 
  onCountryChange,
  showCountry = true,
}) {
  // Configurable style variables
  const FONT_SIZE = '14px';
  const FONT_WEIGHT_BASE = 400;
  const FONT_WEIGHT_SELECT = 400;

  const languageOptions = Object.values(LANGUAGES).map(({ code, label }) => ({
    value: code,
    label: label
  }));
  
  const customStyles = {
    control: (base) => ({
      ...base,
      minWidth: 100,
      minHeight: '48px',
      borderRadius: '25px',
      paddingLeft: '8px',
      paddingRight: '8px',
      fontSize: FONT_SIZE,
      fontFamily: '"Graphik Arabic", sans-serif',
      fontWeight: FONT_WEIGHT_BASE,
      flexDirection: 'row-reverse',
    }),
    option: (base, { isFocused }) => ({
      ...base,
      color: '#000000',
      fontSize: FONT_SIZE,
      fontFamily: '"Graphik Arabic", sans-serif',
      fontWeight: FONT_WEIGHT_BASE,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      backgroundColor: 'transparent',
      padding: 0,
    }),
    singleValue: (base) => ({
      ...base,
      color: '#000000',
      fontSize: FONT_SIZE,
      fontFamily: '"Graphik Arabic", sans-serif',
      fontWeight: FONT_WEIGHT_BASE,
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      textAlign: 'right',
      width: '100%',
      justifyContent: 'flex-end',
    }),
    menuList: (base) => ({
      ...base,
    }),
    menu: (base) => ({
      ...base,
      overflow: 'hidden',
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    input: (base) => ({
      ...base,
      fontSize: FONT_SIZE,
      cursor: 'default',
      caretColor: 'transparent'
    })
  };

  const countrySelectStyles = {
    ...customStyles,
    control: (base) => ({
      ...base,
      width: '130px',
      minHeight: '48px',
      borderRadius: '25px',
      paddingLeft: '8px',
      paddingRight: '8px',
      fontFamily: '"Graphik Arabic", sans-serif',
      fontWeight: FONT_WEIGHT_SELECT,
      flexDirection: 'row-reverse',
    }),
  };

  const languageSelectStyles = {
    ...customStyles,
    control: (base) => ({
      ...base,
      width: '110px',
      minHeight: '48px',
      borderRadius: '25px',
      paddingLeft: '8px',
      paddingRight: '8px',
      fontFamily: '"Graphik Arabic", sans-serif',
      fontWeight: FONT_WEIGHT_SELECT,
      flexDirection: 'row-reverse',
    })
  };

  
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {showCountry && (
        <Select
          className="country-select"
          classNamePrefix="select"
          defaultValue={countryOptions[0]}
          value={countryOptions.find(option => option.value === country)}
          onChange={(option) => onCountryChange({ target: { value: option.value }})}
          options={countryOptions}
          styles={countrySelectStyles}
          isRtl={false}
          components={{ DropdownIndicator: DropdownIcon }}
        />
      )}
      <Select
        className="language-select"
        classNamePrefix="select"
        value={languageOptions.find(option => option.value === language)}
        onChange={(option) => onLanguageChange({ target: { value: option.value }})}
        options={languageOptions}
        styles={languageSelectStyles}
        isRtl={false}
        components={{ DropdownIndicator: DropdownIcon, Option: CustomOption }}
      />
    </Box>
  );
}

export default LanguageSelector;